import { useState } from 'react';

export interface ThemeManagerState {
  selectedTheme: string;
  setSelectedTheme: (theme: string) => void;
  selectedComponent: string;
  setSelectedComponent: (component: string) => void;
  customColors: Record<string, Record<string, string>>;
  setCustomColors: React.Dispatch<React.SetStateAction<Record<string, Record<string, string>>>>;
  availableThemes: any[];
  setAvailableThemes: (themes: any[]) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  isSaving: boolean;
  setIsSaving: (saving: boolean) => void;
  isResetting: boolean;
  setIsResetting: (resetting: boolean) => void;
  showSuccess: boolean;
  setShowSuccess: (show: boolean) => void;
  showResetSuccess: boolean;
  setShowResetSuccess: (show: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  copied: boolean;
  setCopied: (copied: boolean) => void;
}

export const useThemeManagerState = (): ThemeManagerState => {
  const [selectedTheme, setSelectedTheme] = useState('standard');
  const [selectedComponent, setSelectedComponent] = useState('navbar');
  const [customColors, setCustomColors] = useState<Record<string, Record<string, string>>>({});
  const [availableThemes, setAvailableThemes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showResetSuccess, setShowResetSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [copied, setCopied] = useState(false);

  return {
    selectedTheme,
    setSelectedTheme,
    selectedComponent,
    setSelectedComponent,
    customColors,
    setCustomColors,
    availableThemes,
    setAvailableThemes,
    isLoading,
    setIsLoading,
    isSaving,
    setIsSaving,
    isResetting,
    setIsResetting,
    showSuccess,
    setShowSuccess,
    showResetSuccess,
    setShowResetSuccess,
    error,
    setError,
    copied,
    setCopied,
  };
};
